import { useEffect, useState } from 'react';
import { WaveCard } from './WaveCard';

export const WaveCardWithData = ({
    id,
    topColor,
    title,
    subText,
    bodyText,
    src,
    fetchFunc,
    flipTitleDisplay,
    hideShadow,
    to,
}) => {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    useEffect(() => {
        if (fetchFunc) {
            setLoading(true);
            fetchFunc()
                .then((stats) => {
                    setData(stats);
                    setError(null);
                })
                .catch((error) => setError(error))
                .finally(() => setLoading(false));
        }
    }, [fetchFunc]);

    return (
        <WaveCard
            id={id}
            topColor={topColor}
            title={loading ? 'Laster...' : error ? '' : typeof title === 'function' ? title(data) : title}
            subText={subText}
            bodyText={error ? 'Kunne ikke hente data' : typeof bodyText === 'function' ? bodyText(data) : bodyText}
            src={src}
            flipTitleDisplay={flipTitleDisplay}
            hideShadow={hideShadow}
            to={to}
        />
    );
};
